import { AnimatePresence, motion } from 'framer-motion'
import { Upload } from 'lucide-react'
const DragOverlayContent = () => (
  <div className="bg-background/90 px-8 py-4 rounded-xl shadow-2xl border flex items-center gap-4 scale-110">
    <div className="p-3 bg-primary/10 rounded-xl">
      <Upload className="h-6 w-6 text-primary animate-bounce" />
    </div>
    <div className="flex flex-col">
      <span className="text-lg font-bold text-primary">Drop to attach files</span>
      <span className="text-xs text-muted-foreground">Release anywhere to choose a task</span>
    </div>
  </div>
)
export function GlobalDragOverlay({ isDragging, isOverTask }) {
  return (
    <AnimatePresence>
      {isDragging && !isOverTask && (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          exit={{
            opacity: 0,
          }}
          className="fixed inset-0 z-[100] bg-primary/10 backdrop-blur-[2px] border-4 border-dashed border-primary m-4 rounded-xl flex items-center justify-center pointer-events-none"
        >
          <DragOverlayContent />
        </motion.div>
      )}
    </AnimatePresence>
  )
}
